import ErrorBlock from "./common/part/ErrorBlock";
import {LoadPages} from "./useAppConfigStore";


export const BackgroundComponents = () => (
    <ErrorBlock key="backgroundComponents">
        <LoadPages/>
    </ErrorBlock>
)
